<template>
  <div class="nav-bar-rh">
    <img
      src="@/assets/logogruas.png"
      alt="HomePage"
      @click="backModule"
      class="logo-button"
    />
  </div>

  <main class="page">
    <header class="page-header">
      <div>
        <h2>Personal</h2>
        <p class="subtitle">Tabla del personal con filtros por columna.</p>
      </div>

      <button
        v-if="hasPerm('rrhh.create_employee')"
        @click="addEmployee"
        class="btn btn-primary"
      >
        Agregar nuevo personal
      </button>
    </header>

    <section class="table-section">
      <div class="table-head">
        <h3>Tabla del personal</h3>

        <div class="meta">
          <span class="chip">Total: <b>{{ n_employees }}</b></span>
          <span class="chip">Página <b>{{ currentPage }}</b> / <b>{{ totalEmployeesPages }}</b></span>
        </div>
      </div>

      <div v-if="!hasPerm('rrhh.view_employee_list')" class="no-access">
        No tienes permisos para ver el listado de personal.
      </div>
      <div v-else class="table-wrap">
        <table class="table">
          <colgroup>
            <col style="width: 110px" />
            <col style="width: 360px" />
            <col style="width: 220px" />
            <col style="width: 220px" />
            <col style="width: 160px" />
          </colgroup>

          <thead>
            <tr class="head-row">
              <th>ID</th>
              <th>Nombre completo</th>
              <th>Posición</th>
              <th>Departamento</th>
              <th>Estatus</th>
            </tr>

            <tr class="filter-row">
              <th>
                <input v-model="filters.employee_ident" @input="applyFiltersEmployee" placeholder="Buscar por ID" />
              </th>
              <th>
                <input v-model="filters.employee_first_name" @input="applyFiltersEmployee" placeholder="Buscar por nombre" />
              </th>
              <th>
                <input v-model="filters.employee_position" @input="applyFiltersEmployee" placeholder="Buscar por posición" />
              </th>
              <th>
                <input v-model="filters.employee_department" @input="applyFiltersEmployee" placeholder="Buscar por departamento" />
              </th>
              <th>
                <input v-model="filters.employee_status" @input="applyFiltersEmployee" placeholder="Buscar por estatus" />
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(employee, index) in paginatedEmployees"
              :key="index"
              class="row"
              @click="viewEmployeeDetails(employee.employee_ident)"
              title="Click para ver detalles"
            >
              <td><span class="id-pill">{{ employee.employee_ident }}</span></td>
              <td class="name">
                {{ employee.employee_first_name }} {{ employee.employee_last_name }} {{ employee.employee_last_name2 }}
              </td>
              <td>{{ employee.employee_position }}</td>
              <td>{{ employee.employee_department }}</td>
              <td>
                <span
                  class="status"
                  :class="{
                    'is-active': isEmployeeStatusActive(employee),
                    'is-inactive': isEmployeeStatusInactive(employee),
                  }"
                >
                  {{ getEmployeeStatusLabel(employee) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <button class="icon-btn" @click="prevPage" :disabled="currentPage === 1" aria-label="Anterior">
          <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
        </button>

        <div class="pages">
          <span
            v-for="pageNumber in totalEmployeesPages"
            :key="pageNumber"
            @click="goToPage(pageNumber)"
            class="page-pill"
            :class="{ active: pageNumber === currentPage }"
          >
            {{ pageNumber }}
          </span>
        </div>

        <button class="icon-btn" @click="nextPage" :disabled="currentPage >= totalEmployeesPages" aria-label="Siguiente">
          <img src="@/assets/angulo-derecho.png" alt="Next Page" />
        </button>
      </div>
    </section>
  </main>
</template>

<style scoped>
:root {
  --bg: #f6f7f9;
  --surface: #ffffff;
  --surface-2: #fbfbfc;
  --border: #e3e6ea;
  --text: #1f2937;
  --muted: #6b7280;
  --shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  --radius: 16px;
  --brand: #ffc434;
  --brand-soft: rgba(255, 196, 52, 0.22);
}

* {
  box-sizing: border-box;
}
body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue",
    Arial;
}

.nav-bar-rh {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 64px;
  background-color: var(--brand);
  z-index: 1000;
}
.logo-button {
  position: absolute;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  margin: 0;
}

.page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 86px 16px 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
}
.page-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 900;
}
.subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--muted);
}

.btn {
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  padding: 10px 14px;
  border-radius: 14px;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  transition: transform 0.06s ease, filter 0.15s ease;
}
.btn:active {
  transform: translateY(1px);
}
.btn-primary {
  background: linear-gradient(180deg, #ffd36b 0%, #ffc434 100%);
  border-color: rgba(0, 0, 0, 0.12);
  color: #151515;
  box-shadow: 0 10px 20px rgba(255, 196, 52, 0.18);
}
.btn-primary:hover {
  filter: brightness(0.97);
}

.table-section {
  background: transparent;
  margin-top: 8px;
}
.table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 4px;
  border-bottom: 1px solid var(--border);
}
.table-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 900;
}
.meta {
  display: flex;
  gap: 8px;
}
.chip {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.table-wrap {
  overflow: visible;
  margin-top: 8px;
}
.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 13px;
}
.table th,
.table td {
  padding: 12px 10px;
  border-bottom: 1px solid rgba(227, 230, 234, 0.9);
  text-align: left;
  vertical-align: middle;
}
.head-row th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f3f4f6;
  color: var(--muted);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.3px;
  border-top: 1px solid var(--border);
}
.filter-row th {
  position: sticky;
  top: 42px;
  z-index: 1;
  background: #ffffff;
  padding-top: 8px;
  padding-bottom: 10px;
}
.table thead input {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border-radius: 12px;
  border: 1px solid #d7dbe0;
  outline: none;
  font-size: 13px;
  background: #fff;
}
.table thead input:focus {
  border-color: rgba(255, 196, 52, 0.9);
  box-shadow: 0 0 0 3px rgba(255, 196, 52, 0.22);
}

.row {
  cursor: pointer;
}
.row:hover td {
  background: #fafafa;
}

.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.id-pill {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--brand-soft);
  border: 1px solid rgba(255, 196, 52, 0.35);
  font-weight: 900;
  color: #111827;
}

.status {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #f3f4f6;
  font-size: 12px;
  font-weight: 800;
}
.status.is-active {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.28);
  color: #065f46;
}
.status.is-inactive {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.28);
  color: #7f1d1d;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 0 0;
}
.icon-btn {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  border: 1px solid var(--border);
  background: var(--surface);
  display: grid;
  place-items: center;
  padding: 0;
  cursor: pointer;
  flex: 0 0 auto;
}
.icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.icon-btn img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  display: block;
}

.pages {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 70vw;
}
.page-pill {
  user-select: none;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  font-size: 12px;
  font-weight: 800;
}
.page-pill.active {
  background: rgba(255, 196, 52, 0.25);
  border-color: rgba(255, 196, 52, 0.45);
}

.table-wrap table.table {
  display: table !important;
  width: 100% !important;
}
.table-wrap thead {
  display: table-header-group !important;
}
.table-wrap tbody {
  display: table-row-group !important;
}
.table-wrap tr {
  display: table-row !important;
}
.table-wrap th,
.table-wrap td {
  display: table-cell !important;
}

.table-wrap th,
.table-wrap td {
  width: auto !important;
}

.table-wrap .table {
  table-layout: fixed !important;
  min-width: 0 !important;
}

.table-wrap th,
.table-wrap td {
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
  vertical-align: middle !important;
}

.table-wrap td:nth-child(2) {
  white-space: normal !important;
  line-height: 1.25;
}

.table thead input {
  width: 100% !important;
}

.no-access {
  margin: 16px 0;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #f3c7c7;
  background: #fff3f3;
  color: #9b1c1c;
  font-weight: 700;
}
</style>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'RHPersonal',
  data() {
    return {
      currentPage: 1,
      pageSize: 12,
      employees: [],
      n_employees: 0,
      permissions: [],
      filters: {
        employee_ident: '',
        employee_first_name: '',
        employee_position: '',
        employee_department: '',
        employee_status: '',
      },
      originalEmployees: [],
    }
  },
  computed: {
    paginatedEmployees() {
      return this.employees
    },
    totalEmployeesPages() {
      return Math.ceil(this.n_employees / this.pageSize)
    },
  },
  mounted() {
    this.loadPermissions()
    this.fetchEmployees()
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    backModule() {
      this.$router.push({ name: 'RHModule' })
    },
    addEmployee() {
      this.$router.push({ name: 'AddNewEmployee' })
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber
      this.fetchEmployees(this.currentPage)
    },
    async fetchEmployees(page = 1) {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        if (!this.hasPerm('rrhh.view_employee_list')) {
          return
        }
        const response = await axios.post(
          `${apiDirectory}/get-employee?page=${page}&page_size=${this.pageSize}`,
          this.filters
        )
        const responseData = response.data.results
        this.employees = responseData
        this.n_employees = response.data.count
        this.originalEmployees = [...responseData]
      } catch (error) {
        console.error('Error fetching data from API:', error)
      }
    },
    nextPage() {
      if (this.currentPage < this.totalEmployeesPages) this.currentPage++
      this.fetchEmployees(this.currentPage)
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--
      this.fetchEmployees(this.currentPage)
    },
    applyFiltersEmployee() {
      this.fetchEmployees()
    },
    getEmployeeStatusLabel(employee) {
      const statusValue = employee?.employee_status
      if (typeof statusValue === 'string' && statusValue.trim()) return statusValue.trim()
      if (typeof statusValue === 'object' && statusValue?.status) return String(statusValue.status).trim()
      if (statusValue === 1) return 'Activo'
      if (statusValue === 2) return 'Inactivo'
      return 'Sin estatus'
    },
    isEmployeeStatusActive(employee) {
      const label = this.getEmployeeStatusLabel(employee).toLowerCase()
      return label.includes('activo') && !label.includes('inactivo')
    },
    isEmployeeStatusInactive(employee) {
      const label = this.getEmployeeStatusLabel(employee).toLowerCase()
      return label.includes('inactivo') || label.includes('baja')
    },
    viewEmployeeDetails(employee_ident) {
      if (!this.hasPerm('rrhh.view_employee_detail')) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver detalles.', 'warning')
        return
      }
      Swal.fire({
        title: '¿Estás seguro?',
        text: `¿Quieres ver los detalles del personal con el ID ${employee_ident}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, ver detalles',
        cancelButtonText: 'No, cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push({ name: 'EditProfile', params: { employee_ident } })
        }
      })
    },
  },
}
</script>
